const isEditableElement = (element) => {
  if (!element) {
    return false;
  }

  const tagName = element.tagName && element.tagName.toLowerCase();

  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    element.isContentEditable
  );
};

export default isEditableElement;
